import { CdrButton as F, CdrLink as q, IconCaretDown as z, IconExternalLink as H, CdrInput as K, CdrSwitch as G, IconInformationStroke as Z, IconMyLocation as j, IconSearch as J, IconWarningFill as Q } from "@rei/cedar";
import { defineComponent as M, resolveComponent as u, openBlock as t, createElementBlock as a, Fragment as k, renderList as g, normalizeClass as S, createElementVNode as o, toDisplayString as l, createTextVNode as h, createVNode as _, withCtx as m, createCommentVNode as n, pushScopeId as V, popScopeId as O, withKeys as X, createSlots as Y, createBlock as B } from "vue";
const E = M({
  name: "StorePickupModalStoreList",
  components: {
    CdrButton: F,
    CdrLink: q,
    IconCaretDown: z,
    IconExternalLink: H
  },
  props: {
    storeList: {
      type: Array,
      required: !0
    },
    btnText: {
      type: String,
      required: !1,
      default: "Change store"
    },
    preferredStoreId: {
      required: !1,
      type: Number,
      default: 0
    }
  },
  emits: ["addToCartPickup"],
  data() {
    return {
      detailsExpanded: {}
    };
  },
  methods: {
    isPreferredStore(e) {
      return this.preferredStoreId === e;
    },
    toggleExpandDetails(e) {
      this.detailsExpanded[e] = !this.detailsExpanded[e];
    },
    getAvailabilityStatus(e, r) {
      let i = "";
      switch (e) {
        case "UNKNOWN":
          r === "AVAILABLE" && (i = "In Stock");
          break;
        case "BOPUS":
          i = "In Stock";
          break;
        case "RSPU":
          i = "Ship it to store";
          break;
        case "UNFULFILLABLE":
          i = "Out of stock";
          break;
        default:
          i = "";
      }
      return i;
    },
    getAvailabilityAction(e, r) {
      let i = "";
      if (e === "RSPU" && r === "-1")
        return i;
      switch (e) {
        case "BOPUS":
          i = "Pick up";
          break;
        case "RSPU":
          i = "Ready";
          break;
        case "UNFULFILLABLE":
        default:
          i = "";
      }
      return i;
    },
    isLegacyEAD(e) {
      return e == null ? void 0 : e.includes("displays in cart");
    },
    /* Checks if the timestamp contains the calendar date strings. */
    isTodayOrTomorrow(e) {
      var r, i;
      return typeof e == "string" ? ((r = e == null ? void 0 : e.toLowerCase()) == null ? void 0 : r.includes("today")) || ((i = e == null ? void 0 : e.toLowerCase()) == null ? void 0 : i.includes("tomorrow")) : !1;
    }
  }
});
const R = (e, r) => {
  const i = e.__vccOpts || e;
  for (const [L, w] of r)
    i[L] = w;
  return i;
}, b = (e) => (V("data-v-67e328ab"), e = e(), O(), e), x = {
  id: "store-results-list",
  class: "sp-modal-store-list"
}, ee = ["data-ui"], se = {
  class: "sp-modal-store-list__store-results-heading"
}, oe = ["data-ui"], te = ["data-ui"], ae = {
  class: "sp-modal-store-list__store-pickup-options"
}, re = ["data-ui"], ie = ["data-ui"], le = {
  class: "sp-modal-store-list__action"
}, de = {
  class: "sp-modal-store-list__store-entry-bottom"
}, ne = {
  class: "sp-modal-store-list__store-details-link"
}, ce = {
  key: 0,
  class: "sp-modal-store-list__sr-only"
}, pe = ["id"], ue = {
  key: 0,
  class: "sp-modal-store-list__detail-block"
}, _e = /* @__PURE__ */ b(() => /* @__PURE__ */ o("div", {
  class: "sp-modal-store-list__detail-block-heading"
}, " Curbside pickup hours ", -1)), me = {
  class: "sp-modal-store-list__store-hours"
}, he = {
  class: "sp-modal-store-list__store-hours-day"
}, ke = {
  class: "sp-modal-store-list__store-hours-range"
}, ge = {
  key: 1,
  class: "sp-modal-store-list__detail-block"
}, Se = /* @__PURE__ */ b(() => /* @__PURE__ */ o("div", {
  class: "sp-modal-store-list__detail-block-heading"
}, " Store hours ", -1)), fe = {
  class: "sp-modal-store-list__store-hours"
}, be = {
  class: "sp-modal-store-list__store-hours-day"
}, ye = {
  class: "sp-modal-store-list__store-hours-range"
}, ve = {
  key: 2,
  class: "sp-modal-store-list__detail-block"
}, $e = {
  class: "sp-modal-store-list__detail-block-heading"
}, Le = {
  class: "sp-modal-store-list__detail-block"
}, we = /* @__PURE__ */ b(() => /* @__PURE__ */ o("div", {
  class: "sp-modal-store-list__detail-block-heading"
}, " Store address ", -1)), Ie = {
  class: "sp-modal-store-list__address"
}, Ce = {
  class: "sp-modal-store-list__address"
}, Te = /* @__PURE__ */ b(() => /* @__PURE__ */ o("span", {
  class: "sp-modal-store-list__sr-only"
}, " (Opens in a new window)", -1)), Ae = {
  class: "sp-modal-store-list__detail-block"
}, Ne = {
  key: 0,
  class: "sp-modal-store-list__store-entry"
}, Pe = /* @__PURE__ */ b(() => /* @__PURE__ */ o("div", {
  class: "sp-modal-store-list__store-results-heading"
}, [/* @__PURE__ */ o("span", {
  class: "sp-modal-store-list__store-name"
}, "Not available")], -1));
function Ue(e, r, i, L, w, W) {
  const I = u("icon-caret-down"), f = u("cdr-link"), C = u("cdr-button"), T = u("icon-external-link");
  return t(), a("ul", x, [(t(!0), a(k, null, g(e.storeList, (s, d) => {
    var y, v, $, c, A, N, P;
    return t(), a("li", {
      key: s.store.storeId,
      class: S(["sp-modal-store-list__store-entry", {
        "sp-modal-store-list__store-entry--unavailable": s.inventoryStatus === "NOT_AVAILABLE"
      }]),
      "data-ui": `product-store-${d}`
    }, [o("div", se, [o("span", {
      class: "sp-modal-store-list__store-name",
      "data-ui": `product-store-name-${d}`
    }, l(s.store.storeName), 9, oe), o("span", {
      class: "sp-modal-store-list__store-distance",
      "data-ui": `product-store-miles-${d}`
    }, l(s.store.distanceMessage), 9, te)]), o("div", ae, [o("span", {
      class: S(["sp-modal-store-list__availability", s.storeFulfillmentType === "BOPUS" && "sp-modal-store-list__availability--bopus", s.storeFulfillmentType === "RSPU" && "sp-modal-store-list__availability--rspu", s.storeFulfillmentType === "UNFULFILLABLE" && "sp-modal-store-list__availability--unfulfillable", s.storeFulfillmentType === "UNKNOWN" && s.inventoryStatus === "AVAILABLE" && "sp-modal-store-list__availability--available"]),
      "data-ui": `product-store-fulfillment-${d}`
    }, l(e.getAvailabilityStatus(s.storeFulfillmentType, s.inventoryStatus)), 11, re), o("span", {
      class: "sp-modal-store-list__ead-wrapper",
      "data-ui": `product-store-EAD-${d}`
    }, [e.isLegacyEAD(s.estimatedArrivalDate) && s.storeFulfillmentType !== "UNFULFILLABLE" ? (t(), a(k, {
      key: 0
    }, [h(l(s.estimatedArrivalDate), 1)], 64)) : (t(), a(k, {
      key: 1
    }, [o("span", le, l(`${e.getAvailabilityAction(s.storeFulfillmentType, s.estimatedArrivalDate)} `), 1), o("span", {
      class: S(["sp-modal-store-list__ead", s.storeFulfillmentType !== "UNFULFILLABLE" && "sp-modal-store-list__ead--bold", s.storeFulfillmentType === "UNKNOWN" && s.inventoryStatus === "AVAILABLE" && "sp-modal-store-list__ead--hidden"])
    }, l(e.isTodayOrTomorrow(s.estimatedArrivalTimestamp) ? s.estimatedArrivalTimestamp : s.estimatedArrivalDate === "-1" ? "" : s.estimatedArrivalDate), 3)], 64))], 8, ie)]), o("div", de, [o("div", ne, [_(f, {
      tag: "button",
      modifier: "standalone",
      "aria-controls": `store-details-${d}`,
      "aria-expanded": `${e.detailsExpanded[d] === !0}`,
      "data-ui": e.detailsExpanded[d] ? `product-pick-up-in-store-collapse-${d}` : `product-pick-up-in-store-expand-${d}`,
      onClick: (p) => e.toggleExpandDetails(d)
    }, {
      default: m(() => [h(" Store Details "), e.detailsExpanded[d] ? (t(), a("span", ce, " displayed below ")) : n("", !0), _(I, {
        class: S(["sp-modal-store-list__store-details-disclosure sp-modal-store-list__icon-right", {
          "sp-modal-store-list__store-details-disclosure--expanded": e.detailsExpanded[d]
        }]),
        "inherit-color": ""
      }, null, 8, ["class"])]),
      _: 2
    }, 1032, ["aria-controls", "aria-expanded", "data-ui", "onClick"])]), _(C, {
      class: "sp-modal-store-list__change-store-button",
      modifier: e.isPreferredStore(s.store.storeId) ? "secondary" : void 0,
      "data-ui": `product-pick-up-here-button-${d}`,
      "full-width": !0,
      onClick: (p) => e.$emit("addToCartPickup", s)
    }, {
      default: m(() => [h(l(e.isPreferredStore(s.store.storeId) ? "Current store" : e.btnText), 1)]),
      _: 2
    }, 1032, ["modifier", "data-ui", "onClick"])]), e.detailsExpanded[d] ? (t(), a("div", {
      key: 0,
      id: `store-details-${d}`,
      class: "sp-modal-store-list__store-entry-details"
    }, [s.store.enabledForCurbside && ((v = (y = s.store) == null ? void 0 : y.curbsideHours) != null && v.length) ? (t(), a("div", ue, [_e, o("ul", me, [(t(!0), a(k, null, g(s.store.curbsideHours, (p) => (t(), a("li", {
      key: `curbside-${p.weekdayRange}`
    }, [o("span", he, l(p.weekdayRange) + " ", 1), o("span", ke, l(p.hourRange), 1)]))), 128))])])) : n("", !0), s.store.enabledForInStore && ((c = ($ = s.store) == null ? void 0 : $.storeHours) != null && c.length) ? (t(), a("div", ge, [Se, o("ul", fe, [(t(!0), a(k, null, g(s.store.storeHours, (p) => (t(), a("li", {
      key: `curbside-${p.weekdayRange}`
    }, [o("span", be, l(p.weekdayRange) + " ", 1), o("span", ye, l(p.hourRange), 1)]))), 128))])])) : n("", !0), (N = (A = s.store) == null ? void 0 : A.specialStoreHours) != null && N.length ? (t(), a("div", ve, [(t(!0), a(k, null, g(s.store.specialStoreHours, (p) => (t(), a("div", {
      key: p.storeEvent
    }, [o("div", $e, l(p.storeEvent), 1), (t(!0), a(k, null, g(p.formattedDate, (U) => (t(), a("div", {
      key: U,
      class: "sp-modal-store-list__store-hours-range"
    }, l(U), 1))), 128))]))), 128))])) : n("", !0), o("div", Le, [we, o("p", Ie, l((P = s.store.storeAddress) == null ? void 0 : P.line1), 1), o("p", Ce, l(s.store.storeAddress.city) + ", " + l(s.store.storeAddress.state) + " " + l(s.store.storeAddress.zipCode), 1), _(f, {
      class: "sp-modal-store-list__store-directions-link",
      modifier: "standalone",
      rel: "noopener noreferrer",
      target: "_blank",
      href: `https://maps.google.com/maps?q=REI,${s.store.storeAddress.line1},${s.store.storeAddress.city},${s.store.storeAddress.state},${s.store.storeAddress.zipCode}`
    }, {
      default: m(() => [h(" Directions "), Te, _(T, {
        "inherit-color": "",
        class: "sp-modal-store-list__icon-right"
      })]),
      _: 2
    }, 1032, ["href"])]), o("div", Ae, [_(f, {
      modifier: "standalone",
      href: `tel:${s.store.phoneNumber}`
    }, {
      default: m(() => [h(l(s.store.phoneNumber), 1)]),
      _: 2
    }, 1032, ["href"])])], 8, pe)) : n("", !0)], 10, ee);
  }), 128)), e.storeList.length ? n("", !0) : (t(), a("li", Ne, [Pe, h(" This item is not available in stores. ")]))]);
}
const Be = /* @__PURE__ */ R(E, [["render", Ue], ["__scopeId", "data-v-67e328ab"]]), Fe = M({
  name: "StorePickupModal",
  components: {
    CdrButton: F,
    CdrInput: K,
    CdrLink: q,
    CdrSwitch: G,
    IconInformationStroke: Z,
    IconMyLocation: j,
    IconSearch: J,
    IconWarningFill: Q,
    StorePickupModalStoreList: Be
  },
  props: {
    brandName: {
      default: "",
      required: !1,
      type: String
    },
    btnText: {
      required: !1,
      type: String,
      default: "Change store"
    },
    hasError: {
      required: !0,
      type: Boolean
    },
    hasWarning: {
      required: !0,
      type: Boolean
    },
    imageSrc: {
      default: "/media/00000000-0000-0000-0000-000000000000",
      required: !1,
      type: String
    },
    loading: {
      required: !0,
      type: Boolean
    },
    messageBody: {
      type: String,
      required: !1,
      default: ""
    },
    messageTitle: {
      type: String,
      required: !1,
      default: ""
    },
    noStorePickupMessage: {
      type: String,
      required: !1,
      default: ""
    },
    preferredStoreId: {
      required: !1,
      type: Number,
      default: 0
    },
    problemMessage: {
      required: !0,
      type: String
    },
    productName: {
      required: !0,
      type: String
    },
    searchTerm: {
      type: String,
      required: !1,
      default: ""
    },
    showGeo: {
      required: !0,
      type: Boolean
    },
    size: {
      required: !0,
      type: String
    },
    storeList: {
      required: !0,
      type: Array
    },
    showInStockStores: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["getUserLocation", "storeSearchClick", "addToCartPickup", "registerSPSearchRef"],
  data() {
    return {
      componentSearchTerm: this.searchTerm,
      skeletonSize: 4,
      showInStockStoresToggle: this.showInStockStores
    };
  },
  computed: {
    storeUpdateMessage() {
      return this.loading ? "Store list loading" : `Store locations updated, ${this.storeList.length} results showing`;
    },
    problemMessageClass() {
      return {
        "sp-modal__problem-text": !0,
        "sp-modal__problem-text--err": this.hasError,
        "sp-modal__problem-text--warn": this.hasWarning
      };
    },
    inStockStoreList() {
      return this.storeList.filter((e) => {
        const {
          inventoryStatus: r,
          storeFulfillmentType: i
        } = e;
        return r === "AVAILABLE" && (i === "BOPUS" || i === "UNKNOWN");
      });
    }
  },
  watch: {
    searchTerm(e) {
      this.componentSearchTerm = e;
    }
  },
  mounted() {
    var r, i;
    const e = (i = (r = this.$refs.storePickupSearch) == null ? void 0 : r.$el) == null ? void 0 : i.querySelector("input");
    this.$emit("registerSPSearchRef", e);
  }
});
const D = (e) => (V("data-v-708e30b0"), e = e(), O(), e), qe = {
  class: "sp-modal",
  "data-ui": "sp-modal-container"
}, Me = {
  class: "sp-modal__search-box"
}, Ve = {
  class: "sp-modal__geolocation"
}, Oe = {
  key: 0,
  class: "sp-modal__sr-only"
}, Re = ["innerHTML"], De = {
  id: "a11y-update-text",
  class: "sp-modal__sr-only",
  "aria-live": "polite"
}, We = /* @__PURE__ */ D(() => /* @__PURE__ */ o("span", {
  class: "sp-modal__show-in-stock-stores-label"
}, "Show in-stock stores only", -1)), ze = {
  key: 1,
  class: "sp-modal__restrictions"
}, He = {
  key: 2
}, Ke = {
  key: 0,
  class: "sp-modal__message-wrapper"
}, Ge = {
  key: 0,
  class: "sp-modal__message-title",
  "data-ui": "sp-modal-generic-message-title"
}, Ze = {
  key: 1,
  class: "sp-modal__message-body",
  "data-ui": "sp-modal-generic-message-body"
}, je = {
  key: 1,
  "aria-hidden": "true",
  class: "sp-modal__loading"
}, Je = /* @__PURE__ */ D(() => /* @__PURE__ */ o("p", {
  class: "sp-modal__store-list-header"
}, " Searching... ", -1)), Qe = {
  key: 2,
  class: "sp-modal__results",
  "data-ui": "product-pick-up-in-store-store-results"
};
function Xe(e, r, i, L, w, W) {
  const I = u("icon-my-location"), f = u("cdr-link"), C = u("icon-search"), T = u("cdr-button"), s = u("cdr-input"), d = u("icon-warning-fill"), y = u("cdr-switch"), v = u("icon-information-stroke"), $ = u("store-pickup-modal-store-list");
  return t(), a("section", qe, [o("div", Me, [_(s, {
    ref: "storePickupSearch",
    modelValue: e.componentSearchTerm,
    "onUpdate:modelValue": r[2] || (r[2] = (c) => e.componentSearchTerm = c),
    type: "search",
    "aria-invalid": e.hasError,
    class: S(["sp-modal__search-input", {
      "sp-modal__search-input--err": e.hasError
    }]),
    "hide-label": !1,
    "aria-describedby": e.hasError || e.hasWarning ? "problem-message" : void 0,
    autocomplete: "shipping postal-code",
    "data-ui": "product-pick-up-in-store-search",
    label: "Zip Code or City, State *",
    pattern: "[0-9\\-\\s]+",
    onKeyup: r[3] || (r[3] = X((c) => e.$emit("storeSearchClick", e.componentSearchTerm), ["enter"]))
  }, Y({
    "post-icon": m(() => [_(T, {
      "aria-label": "Search by location",
      "icon-only": !0,
      class: "sp-modal__search-button cdr-input__button",
      "data-ui": "product-pick-up-in-store-search-icon",
      onClick: r[1] || (r[1] = (c) => e.$emit("storeSearchClick", e.componentSearchTerm))
    }, {
      default: m(() => [_(C, {
        "inherit-color": !0
      })]),
      _: 1
    })]),
    _: 2
  }, [!e.hasError && !e.hasWarning ? {
    name: "helper-text-bottom",
    fn: m(() => [h(" Example: 98102 or Taos, NM ")]),
    key: "0"
  } : void 0, e.showGeo ? {
    name: "info",
    fn: m(() => [o("div", Ve, [_(f, {
      tag: "button",
      modifier: "standalone",
      onClick: r[0] || (r[0] = (c) => e.$emit("getUserLocation"))
    }, {
      default: m(() => [_(I, {
        class: "sp-modal__geo-icon",
        "inherit-color": ""
      }), h(" Use my location ")]),
      _: 1
    })])]),
    key: "1"
  } : void 0]), 1032, ["modelValue", "aria-invalid", "class", "aria-describedby"]), e.hasError || e.hasWarning ? (t(), a("p", {
    key: 0,
    id: "problem-message",
    class: S(e.problemMessageClass),
    "data-ui": "product-pick-up-in-store-invalid-search"
  }, [_(d, {
    class: "sp-modal__problem-icon",
    "inherit-color": ""
  }), e.hasError ? (t(), a("span", Oe, "Error: ")) : n("", !0), o("span", {
    innerHTML: e.problemMessage
  }, null, 8, Re)], 2)) : n("", !0), o("p", De, l(e.storeUpdateMessage), 1)]), e.storeList.length ? (t(), B(y, {
    key: 0,
    id: "show-in-stock-stores",
    modelValue: e.showInStockStoresToggle,
    "onUpdate:modelValue": r[4] || (r[4] = (c) => e.showInStockStoresToggle = c),
    "data-ui": "sp-modal-show-in-stock-stores",
    class: "sp-modal__show-in-stock-stores",
    "full-width": !0
  }, {
    default: m(() => [We]),
    _: 1
  }, 8, ["modelValue"])) : n("", !0), e.noStorePickupMessage ? (t(), a("div", ze, [_(v, {
    class: "restrictions-icon"
  }), h(" " + l(e.noStorePickupMessage), 1)])) : (t(), a("div", He, [e.messageTitle || e.messageBody ? (t(), a("div", Ke, [e.messageTitle ? (t(), a("h2", Ge, l(e.messageTitle), 1)) : n("", !0), e.messageBody ? (t(), a("p", Ze, l(e.messageBody), 1)) : n("", !0)])) : n("", !0), e.loading ? (t(), a("div", je, [Je, (t(!0), a(k, null, g(e.skeletonSize, (c) => (t(), a("div", {
    key: c,
    class: "sp-modal__skeleton"
  }))), 128))])) : n("", !0), !e.loading && e.storeList.length ? (t(), a("section", Qe, [e.storeList.length ? (t(), B($, {
    key: 0,
    "btn-text": e.btnText,
    "store-list": e.showInStockStoresToggle ? e.inStockStoreList : e.storeList,
    "preferred-store-id": e.preferredStoreId,
    onAddToCartPickup: r[5] || (r[5] = (c) => e.$emit("addToCartPickup", c))
  }, null, 8, ["btn-text", "store-list", "preferred-store-id"])) : n("", !0)])) : n("", !0)]))]);
}
const xe = /* @__PURE__ */ R(Fe, [["render", Xe], ["__scopeId", "data-v-708e30b0"]]);
export {
  xe as default
};
